import { PATHS } from '@client/routes';
import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';

export const RequestingExclusiveModal = ({
  isOpen,
  onClose,
  onContinue,
}: {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Requesting Exclusive Channel "
      disableBackdropClick={true}
      modalClassName="w-full md:w-[742px]"
    >
      <div className="flex flex-col gap-6">
        <Typography variant="body" size="large" className="font-bold">
          By proceeding, you confirm that you have read the{' '}
          <a
            className={clsx('underline', sprinkles({ color: 'P-80' }))}
            href="https://help.playbookapp.io/en/articles/9698798-how-the-exclusive-subscription-model-works"
            target="_blank"
            rel="noreferrer"
          >
            feature guide
          </a>{' '}
          and understand how the exclusive model works. Once you publish your
          program, the price cannot be changed.
        </Typography>
        <Typography>Do you wish to continue?</Typography>
        <div className="flex gap-2 items-center justify-center">
          <Button variant="text" color="neutral" onClick={onClose}>
            Go Back
          </Button>
          <Button color="neutral" onClick={onContinue}>
            Continue
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const selectionOptions = (creatorId: number) => [
  {
    title: 'Category',
    details: 'exercises grouped by theme',
    type: 'category',
    to: PATHS.NEW_CATEGORY(creatorId),
  },
  {
    title: 'Program',
    details: 'exercises grouped as plan',
    type: 'program',
    to: PATHS.NEW_PROGRAM(creatorId),
  },
];
